import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { titleFeatureKey, titleReducer } from './state/title.reducer';

@NgModule({
    declarations: [],
    imports: [
      CommonModule,
      StoreModule.forFeature(titleFeatureKey, titleReducer), 
    ]
  })
  export class TitleModule { }